import ContractActivityDetails from './ContractActivityDetails';

export default ContractActivityDetails;
